<div>
    <div class="header">
        <div>
            <mydocma-custom-mat-icon style="vertical-align: middle; font-size: 16px;" [iconName]="'_info'"></mydocma-custom-mat-icon>Info
        </div>
        <mat-icon (click)="close()" class="nt-close-btn">close</mat-icon>
    </div>
    <div class="upload">
        <p>{{ 'MM.syncFaults.dialog.retrySync' | translate }}:</p>
        <p>{{ 'MM.syncFaults.dialog.retrySyncTooltip' | translate }}</p>
    </div>
    <div class="queue">
        <p>{{ 'MM.syncFaults.dialog.cleanupAndRetrySync' | translate }}:</p>
        <p>{{ 'MM.syncFaults.dialog.cleanupAndRetrySyncTooltip1' | translate }}</p>  
        <p>{{ 'MM.syncFaults.dialog.cleanupAndRetrySyncTooltip2' | translate }}</p>  
    </div>
</div>

